/**
 * Apply values to a container of dangerouslySetInnerHTML-injected fields.
 * Caller should provide the container element appropriate to their component.
 */
export function applyValuesToContainer(
  container: Element | null,
  values: Record<string, string | number | boolean | null | undefined>, 
  isAcroFile: boolean = false
) {
  if (!container) return;
  Object.entries(values).forEach(([key, val]) => {
    let byDataId;
    if(!isAcroFile) {
      byDataId = container.querySelector(
        `[data-id="${CSS.escape(String(key))}"]`
      ) as HTMLElement | null;
    } else {
      byDataId = container.querySelector(
        `[data-field-id="${CSS.escape(String(key))}"]`
      ) as HTMLElement | null;
    }
    const byName = container.querySelector(`[name="${key}"]`) as HTMLElement | null;
    const byId = container.querySelector(`#${CSS.escape(String(key))}`) as HTMLElement | null;
    const el = (byDataId || byName || byId) as
      | HTMLInputElement
      | HTMLTextAreaElement
      | HTMLSelectElement
      | null;
    if (!el) return;

    if (el instanceof HTMLInputElement) {
      if (el.type === "checkbox" || el.type === "radio") {
        el.checked = val === "true" || val === true || val === "1" || val === 1;
      } else if (el.type !== "file") {
        el.value = val != null ? String(val) : "";
      }
    } else if (el instanceof HTMLSelectElement) {
      const stringValue = val != null ? String(val) : "";
      el.value = stringValue;
      const option = Array.from(el.options).find((opt) => opt.value === stringValue);
      if (option) option.selected = true;
    } else if (el instanceof HTMLTextAreaElement) {
      el.value = val != null ? String(val) : "";
    }

    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  });
}
